var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$options.i18n.buttonTitle,"aria-label":_vm.$options.i18n.buttonTitle,"icon":"remove","data-testid":"remove-group-link-button"},on:{"click":function($event){return _vm.showRemoveGroupLinkModal(_vm.groupLink)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }